import { Box, Typography } from '@mui/material';
import { TableV2Column } from 'components/Table/TableV2';
import { AnchorText } from 'components/Text';
import { CandidateBatchGroup } from 'services/candidate/types';
import { DrawerComponentType } from 'services/drawer/types';
import { formatDateFromNow, sortByDate } from 'utils/datetime';

export const getRulesetColumns = ({
  openDrawer
}: {
  openDrawer: (params: {
    drawerContentType: DrawerComponentType;
    drawerComponentProps: any;
  }) => void;
}) => {
  const columns: TableV2Column<CandidateBatchGroup>[] = [
    {
      name: 'Ruleset name',
      cell: (row: CandidateBatchGroup) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <AnchorText
            onClick={() => {
              openDrawer({
                drawerContentType:
                  DrawerComponentType.CandidateRankingGroupEdit,
                drawerComponentProps: {
                  candidateBatchGroup: {
                    id: row.id,
                    name: row.name
                  },
                  hideCloseIconButton: true
                }
              });
            }}
          >
            {row.name}
          </AnchorText>
        </Box>
      )
    },
    {
      name: 'Last updated',
      cell: (row: CandidateBatchGroup) => formatDateFromNow(row.updatedAt),
      sortable: true,
      sortFunction: (a, b) => sortByDate(a.updatedAt, b.updatedAt)
    },
    {
      name: 'Created by',
      cell: (row: CandidateBatchGroup) => (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography>{row.user?.name || '-'}</Typography>
        </Box>
      )
    }
  ];

  return columns;
};
